import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Card, Form, Grid, List, Segment} from 'semantic-ui-react';
import {required, requiredEmail} from '../../../../common/components/form/common/fieldValidations';
import {InputField, DropdownField, CheckboxField} from '../../../../common/components/form';
import {toUpperCase, toLowerCase} from '../../../../common/util/fieldsNormalization';
import {parseAgenciesValues} from '../../../../common/util/options';
import {Actions} from '../../../../common/actions';
import InfoModal from './modal/InfoModal';

class DealerFields extends Component {
  setCheckBoxValue = (e, {checked, name, id, label}) => {
    const {setUserField} = this.props;
    let value = checked ? 'A' : 'I';
    console.log(this.props);
    if (name !== 'status') {
      value = checked ? id : null;
    }
    setUserField(name, value);
    if (name.includes('group')) {
      const nameValue = value ? label : '';
      setUserField(`name${name}`, nameValue);
    }
  }
  
  setCheckBoxValue2 = (e, {checked, name, id, label}) => {
    const {setUserField} = this.props;
    const {rolesList} = this.props.formValues;
    const newRoleList = [...rolesList];
    if (checked) {
      newRoleList.push({'groupId': id, 'groupName': label});
    } else {
      const indexToRemove = newRoleList.indexOf(newRoleList.find((x) => x.groupId === id));
      if (indexToRemove !== -1) {
        newRoleList.splice(indexToRemove, 1);
      }
    }
    setUserField('rolesList', newRoleList);
  };

  getRoleCheckStatus = (groupId) => {
    const {rolesList} = this.props.formValues;
    return rolesList?.find((x) => x.groupId === groupId) ? true : false;
  };

  renderPolicies = (disableField) => {
    const {
      policiesList,
      loadingPermissions,
      permissionsList,
      // formValues,
    } = this.props;

    return policiesList.map((policy, idx) => {
      const group = `group${idx + 1}`;
      const groupId = policy.groups[0].id;

      return (
        <List.Item key={idx}>
          <List.Content>
            {/* <Form.Checkbox
              name={group}
              checked={formValues[group] === groupId}
              id={groupId}
              onChange={this.setCheckBoxValue}
              disabled={disableField}
            /> */}
            <Form.Checkbox
              label={policy.name}
              name={group}
              checked={this.getRoleCheckStatus(groupId)}
              id={groupId}
              onChange={this.setCheckBoxValue2}
              disabled={disableField}
            />
            <InfoModal
              loading={loadingPermissions}
              name={policy.name}
              list={permissionsList}
              id={policy.id}
            />
          </List.Content>
        </List.Item>
      );
    });
  };

  render() {
    const {dealerId, agenciesList, username, formValues, loadingAgencies} = this.props;
    const status = formValues.status;
    const disableField = username && status !== 'A';

    return (
      <Card raised fluid>
        <Grid textAlign='left' className='grid-padding-parameter'>
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Nombre de Usuario</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='name'
                component={InputField}
                required
                type='text'
                normalize={toUpperCase}
                validate={required}
                disabled={disableField || username}
              />
            </Grid.Column>
            {username && (
              <>
                <Grid.Column textAlign='right' verticalAlign='middle' width={3}>
                  <h3>Estado</h3>
                </Grid.Column>
                <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
                  <Form.Checkbox
                    name='status'
                    checked={status === 'A'}
                    onChange={this.setCheckBoxValue}
                    toggle
                  />
                </Grid.Column>
              </>
            )}
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Concesionario</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='dealer'
                component={InputField}
                required
                value={dealerId}
                normalize={toUpperCase}
                type='text'
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Agencia</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='agency'
                component={DropdownField}
                required
                className='agency-selection'
                options={parseAgenciesValues(agenciesList)}
                normalize={toUpperCase}
                disabled={disableField}
                loading={loadingAgencies}
                type='text'
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Correo electrónico</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='email'
                component={InputField}
                validate={requiredEmail}
                disabled={disableField}
                normalize={toLowerCase}
                required
                type='email'
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Fecha de creación</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field name='date' component={InputField} required readOnly />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Solicitante</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='creationUser'
                component={InputField}
                required
                type='text'
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Sistema</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                label='TEMS'
                name='system'
                component={CheckboxField}
                disabled={true}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' width={3}>
              <h3>Perfiles</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Segment>
                <List>{this.renderPolicies(disableField)}</List>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'formValues': state.userForm.values,
    'agenciesList': state.dealer.agenciesList,
    'policiesList': state.userForm.policiesList,
    'permissionsList': state.userForm.permissionsList,
    'rolesList': state.userForm.rolesList,
    'loadingPermissions': state.userForm.loadingPermissions,
    'loadingAgencies': state.dealer.loadingAgencies,
  };
};

const {setUserField} = Actions;

export default connect(mapStateToProps, {
  setUserField,
})(DealerFields);
